import { useEffect, useState } from 'react'
import { Hourglass, Send } from 'lucide-react'

import type { QueryView } from '@krp/client-runtime'

/** Через сколько секунд «запрос отправлен» становится «ждём ответ»: дольше — служба читает кабинет AQSI. */
export const WAIT_AFTER_SECONDS = 2

/**
 * Ход запроса чеков (RP-FB41): отправка, затем ожидание ответа со счётчиком секунд. Закрытые смены и период служба читает из кабинета
 * AQSI, и это может занять заметное время: человек видит, что запрос идёт, а не пустой экран. Ответ получен — компонент исчезает,
 * а экран говорит, откуда и когда прочитаны чеки. Ничего не изображается как уже сделанное.
 */
export function RequestProgress({ query, what }: { query: QueryView; what: string }) {
  const pending = query.status === 'loading' || query.refreshing
  // Счётчик живёт, пока запрос идёт: новый запрос — новый счётчик с нуля.
  return pending ? <Pending what={what} /> : null
}

function Pending({ what }: { what: string }) {
  const [seconds, setSeconds] = useState(0)
  useEffect(() => {
    const started = Date.now()
    const timer = setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 1000)
    return () => clearInterval(timer)
  }, [])
  const waiting = seconds >= WAIT_AFTER_SECONDS
  return (
    <p className="aqsi-journal__note" role="status" aria-live="polite" data-phase={waiting ? 'waiting' : 'sending'}>
      {waiting ? <Hourglass size={16} aria-hidden="true" /> : <Send size={16} aria-hidden="true" />}
      <span>
        {waiting
          ? `${what}: запрос отправлен, ждём ответ — закрытые смены служба читает из кабинета AQSI (прошло ${seconds} с)`
          : `${what}: отправляем запрос…`}
      </span>
    </p>
  )
}
